module.exports = __webpack_public_path__ + "static/media/video_image3.7d987d3e.svg";